import { toast } from "react-toastify";

const Notify = (type: String, message: String) => {
    switch(type) {
        case 'success':
            toast.success(message);
            break;
        case 'error':
            toast.error(message);
            break;
        case 'warning':
            toast.warning(message);
            break;
        default:
            toast.info(message);
    }
}

export default Notify;